exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "create-delegation-help{display:block;border-radius:3px;background-color:#f9f9f9;padding:11px 16px;font-family:ArialMT;font-size:14px;line-height:1.29;letter-spacing:normal;text-align:left;color:#666}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./client/app/components/modalDelegationManager/modalCreateDelegation/createDelegationHelp/createDelegationHelp.scss
// module id = 924
// module chunks = 0